import React from "react";
import i18next from "i18next";
import { Dropdown, Menu } from "antd";
import styled from "styled-components";

import i18n from "../../i18n";

import { Link } from "../styles/Design";

import world_alt_duotone from "../../assets/icons/world_alt_duotone.svg";
import { useMediaQuery } from "react-responsive";

const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin: 0 0.5rem;
`;

const LanguagesMenu = () => {
  const lang = i18next.language;
  const { Item } = Menu;
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    window.location.reload();
  };
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const LanguagesItems = () => (
    <Menu>
      {lang === "en-US" || lang === "en" ? (
        <Item onClick={() => changeLanguage("ar")}>Arabic</Item>
      ) : (
        <Item onClick={() => changeLanguage("en")}>English</Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      overlay={LanguagesItems}
      trigger={["click"]}
      placement="bottomCenter"
      arrow
    >
      <Link to="#" color={isMobile ? "#1B292C" : "white"}>
        <Icon src={world_alt_duotone} />
        {lang === "en-US" || lang === "en" ? "English" : "العربية"}
      </Link>
    </Dropdown>
  );
};

export default LanguagesMenu;
